import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { PaymentService } from '../../modules/payments/services/payment.service';

@Injectable({
  providedIn: 'root',
})
export class SessionsGuard  {
  private totalRequests = 0;

  constructor(
    private _paymentService: PaymentService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.checkTokenSession(); //TODO: VALIDACION DE TOKEN DE SESSION DE PAGO
  }

  checkTokenSession(): boolean {
    try {
      const token = this._paymentService.getAuthToken() != '';
      if (!token) {
        this.router.navigate(['/', 'expired']);
      }
      return token;
    } catch (e) {
      return false;
    }
  }
}
